module Meevo.Components.Controls {
    "use strict";

    export class MeevoDayWeekSelector implements angular.IDirective {
        restrict = "E";
        require = '^form';
        scope = {
            model: "=ngModel",
            selectionList: "=selectionList",
            required: "=ngRequired",
            doHide:"=ngHide",
            disabled: "=ngDisabled",
            maxNumberOfDays: "=?"
        };

        controller = function() {
        }

        templateUrl = "app/components/controls/dayWeekSelectorTemplate.html";

        constructor() {

        }

        link = (scope: any, element: JQuery, attrs: any, form: any) => {
            scope.$watch("doHide", function () {
                validate();
            }, true);

            scope.$watch("selectionList", function () {
                validate();
            }, true);

            function validate() {
                var isInvalid;
                if (scope.doHide)
                    isInvalid = false;
                else
                    isInvalid = (scope.selectionList) ? scope.selectionList.length == 0 : true;

                window.setTimeout(() => form.daysOfWeek.$setValidity("required", !isInvalid), 0);
            }
        }


        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoDayWeekSelector();
            };

            return directive;
        }

    }

    angular.module("meevo.components.controls").directive("meevoDayWeekSelector", MeevoDayWeekSelector.factory());
}